export enum MapBounds {
    west = 10.15,
    east = 11.65,
    north = 48.85,
    south = 47.85,
}
